import { Box, IconButton, List, Typography } from "@mui/material";
import { useContext, useEffect } from "react";

import MusicListItem from "@/components/MusicListItem";
import { MusicContext } from "@/contexts/MusicContext";
import { SubscribedContext } from "@/providers/Subscribed";

import { useMusic, usePrefetchAudioUrls } from "@/services/hooks";
import { PlayCircle } from "@mui/icons-material";

export default function MusicContainer({ artistKey }) {
  const { music, handlePlay, setMusic } = useContext(MusicContext);

  const { data: artistContent } = useMusic(artistKey);

  usePrefetchAudioUrls(artistContent);

  useEffect(() => {
    setMusic(artistContent);
  }, [artistContent]);

  // const isLimited = localStorage.getItem("limited") === "true";

  if (artistContent?.length == 0) {
    return null;
  }

  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);

  const handleClickPlay = () => {
    if (!isSubscribed) {
      handleModalOpen();
      return;
    } else {
      handlePlay(music[0]);
    }
  };

  return (
    <Box
      id="music"
      sx={{
        p: 2, // Reset any padding
      }}
    >
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
        }}
      >
        <Typography variant="h6" sx={{ my: 2, fontWeight: 800 }}>
          Music
        </Typography>
        <IconButton
          color="secondary"
          onClick={handleClickPlay}
          sx={{ px: 0 }}
          // disabled={isLimited}
        >
          <PlayCircle style={{ fontSize: 50 }} />
        </IconButton>
      </Box>

      <List>
        {artistContent?.map((content, index) => (
          <MusicListItem key={index} content={content} />
        ))}
      </List>

      {/* {musicLoading && (
        <Box
          style={{ display: "flex", justifyContent: "center" }}
          sx={{ p: 4 }}
        >
          <CircularProgress />
        </Box>
      )} */}
    </Box>
  );
}
